import type { AuthIdentity } from "../../../api/WarehouseApi";

const PROVIDER_ORDER: Record<AuthIdentity["provider"], number> = {
  email: 1,
  google: 2,
  apple: 3,
  telegram: 4,
};

export function sortAuthIdentities(identities: AuthIdentity[]): AuthIdentity[] {
  return [...identities].sort((left, right) => {
    if (left.provider !== right.provider) {
      return PROVIDER_ORDER[left.provider] - PROVIDER_ORDER[right.provider];
    }

    return left.providerUserId.localeCompare(right.providerUserId, "ru");
  });
}

export function getAuthIdentityProviderLabel(
  provider: AuthIdentity["provider"],
): string {
  if (provider === "email") {
    return "Email";
  }
  if (provider === "google") {
    return "Google";
  }
  if (provider === "apple") {
    return "Apple";
  }

  return "Telegram";
}
